export default __webpack_public_path__ + "static/media/background_decoration2x.0c3a14d1.png";